/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Processing_AriaInputs */



/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Drastic_Tech_Processing_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_processing_aria = /** @type {((inputs?: Drastic_Tech_Processing_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Processing_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tratamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加工")
	if (locale === "ja") return /** @type {LocalizedString} */ ("処理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रसंस्करण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processamento")
	return /** @type {LocalizedString} */ ("Processing")
});